app.controller('InformesCtrl', ['$scope','$sce', function($scope,$sce) {

    $scope.MenuInformes = MenuInformes;
    $scope.url = InformesUrlPowerBi;

    $scope.trustSrc = function(src) {
        return $sce.trustAsResourceUrl(src);
    }

}]);